import { ENV } from "../Utils";

export class TeacherAPI {
  baseApi = ENV.BASE_API;

  // Crear un nuevo Teacher
  async createTeacher(accessToken, formData, institutionId) {
    try {
      const url = `${this.baseApi}/teacher/create/${institutionId}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 201) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en createTeacher:", error);
      throw error;
    }
  }

  // Actualizar un Teacher (campos editables, incluyendo avatar si es necesario)
  async updateTeacher(accessToken, teacherId, formData) {
    try {
      const url = `${this.baseApi}/teacher/upd/${teacherId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en updateTeacher:", error);
      throw error;
    }
  }

  // Obtener todos los Teachers, opcionalmente filtrando por activos
  async getTeachers(accessToken, active = undefined) {
    try {
      const query = active !== undefined ? `?active=${active}` : "";
      const url = `${this.baseApi}/teachers/get${query}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en getTeachers:", error);
      throw error;
    }
  }

  // Obtener un Teacher por ID
  async getTeacherById(accessToken, teacherId) {
    try {
      const url = `${this.baseApi}/teacher/get/${teacherId}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en getTeacherById:", error);
      throw error;
    }
  }
  async getTeachersByInstitution(
    accessToken,
    institutionId,
    { page = 1, limit = 10 } = {},
  ) {
    try {
      const url = `${this.baseApi}/teacher/byinstitution/${institutionId}?page=${page}&limit=${limit}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result; // result contendrá { code, message, teachers, totalDocs, page, limit, totalPages }
    } catch (error) {
      console.error("Error en getTeachersByInstitution:", error);
      throw error;
    }
  }

  // Añadir nuevos classrole a un Teacher
  // classRoleData debe ser { classrole: [ { classnumber: "1ºA", role: "tutor" }, ... ] }
  async addClassRole(accessToken, teacherId, classRoleData) {
    try {
      const url = `${this.baseApi}/teacher/upd/class/${teacherId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(classRoleData),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en addClassRole:", error);
      throw error;
    }
  }

  // Añadir una escena a un classrole específico
  // sceneData debe ser { classnumber: "1ºA", sceneId: "id_de_la_escena" }
  async addSceneToClassrole(accessToken, teacherId, sceneData) {
    try {
      const url = `${this.baseApi}/teacher/upd/scene/${teacherId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sceneData),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en addSceneToClassrole:", error);
      throw error;
    }
  }

  // Añadir un estudiante a un classrole específico
  // studentData debe ser { classnumber: "1ºA", studentId: "id_del_estudiante" }
  async addStudentToClassrole(accessToken, teacherId, studentData) {
    try {
      const url = `${this.baseApi}/teacher/upd/student/${teacherId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(studentData),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en addStudentToClassrole:", error);
      throw error;
    }
  }

  // Eliminar un Teacher por ID
  async deleteTeacher(accessToken, teacherId) {
    try {
      const url = `${this.baseApi}/teacher/delete/${teacherId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en deleteTeacher:", error);
      throw error;
    }
  }

  // Eliminar un classrole específico de un Teacher
  // data debe ser { classnumber: "1ºA" }
  async deleteClassrole(accessToken, teacherId, data) {
    try {
      const url = `${this.baseApi}/teacher/delete/class/${teacherId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en deleteClassrole:", error);
      throw error;
    }
  }

  // Eliminar una escena de un classrole
  // data debe ser { classnumber: "1ºA", sceneId: "id_de_la_escena" }
  async deleteScene(accessToken, teacherId, data) {
    try {
      const url = `${this.baseApi}/teacher/delete/scene/${teacherId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en deleteScene:", error);
      throw error;
    }
  }

  // Eliminar un estudiante de un classrole
  // data debe ser { classnumber: "1ºA", studentId: "id_del_estudiante" }
  async deleteStudent(accessToken, teacherId, data) {
    try {
      const url = `${this.baseApi}/teacher/delete/student/${teacherId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en deleteStudent:", error);
      throw error;
    }
  }
}
